module.exports = __webpack_public_path__ + "lack-of-competition.png?36d3c69283f802b08881b4bdef8afb67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lack-of-competition.png
// module id = 969
// module chunks = 2